
(function(){
  "use strict";

  var REDUCE = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hasGSAP = typeof window.gsap !== 'undefined';
  var hasST = hasGSAP && typeof window.ScrollTrigger !== 'undefined';
  var hasSplit = hasGSAP && typeof window.SplitText !== 'undefined';
  if(hasST) gsap.registerPlugin(ScrollTrigger);
  if(hasSplit) gsap.registerPlugin(SplitText);

  function $(s,ctx){ return (ctx||document).querySelector(s); }
  function $$(s,ctx){ return Array.prototype.slice.call((ctx||document).querySelectorAll(s)); }
  function setIf(t,v){ if(hasGSAP) gsap.set(t,v); }

  /* =========================================================
     HERO SET PIECE · THE FACET ENGINE (procedural canvas)
     A cut obsidian solid built from rings of vertices, lit by an
     orbiting platinum key light, drawn with painter sorting,
     surrounded by a dust field and a scanning assay ring.
     ========================================================= */
  var gemHud = { axis:0, lum:0, facets:0, scan:0 };
  (function facetEngine(){
    var cv = document.getElementById('gemCanvas');
    if(!cv || !cv.getContext) return;
    var ctx = cv.getContext('2d');
    if(!ctx) return;

    var SEG = 14;
    var RINGS = [
      { y:-0.62, r:0.44 },
      { y:-0.34, r:0.76 },
      { y: 0.00, r:1.00 },
      { y: 0.52, r:0.58 }
    ];
    var APEX = { x:0, y:1.18, z:0 };

    // deterministic jitter so the cut reads as stone, not a lathe part
    var seed = 991733;
    function rnd(){ seed = (seed*1103515245 + 12345) & 0x7fffffff; return (seed>>>9)/0x3fffff; }

    var verts = [];
    var ringIdx = [];
    for(var r=0;r<RINGS.length;r++){
      var row = [];
      for(var s=0;s<SEG;s++){
        var a = (s/SEG)*Math.PI*2;
        var jr = RINGS[r].r * (0.975 + rnd()*0.05);
        var jy = RINGS[r].y + (rnd()-0.5)*0.02;
        row.push(verts.length);
        verts.push({ x:Math.cos(a)*jr, y:jy, z:Math.sin(a)*jr });
      }
      ringIdx.push(row);
    }
    var apexI = verts.length; verts.push({x:APEX.x,y:APEX.y,z:APEX.z});
    var tableI = verts.length; verts.push({x:0,y:RINGS[0].y-0.03,z:0});

    var faces = [];
    // table cap
    for(var t=0;t<SEG;t++){
      faces.push([ tableI, ringIdx[0][t], ringIdx[0][(t+1)%SEG] ]);
    }
    // crown and pavilion belts
    for(var b=0;b<RINGS.length-1;b++){
      for(var q=0;q<SEG;q++){
        var q2=(q+1)%SEG;
        faces.push([ ringIdx[b][q], ringIdx[b][q2], ringIdx[b+1][q2], ringIdx[b+1][q] ]);
      }
    }
    // pavilion to apex
    for(var p=0;p<SEG;p++){
      faces.push([ ringIdx[3][p], ringIdx[3][(p+1)%SEG], apexI ]);
    }
    gemHud.facets = faces.length;

    // normalize winding once, so every face normal points away from the solid
    // centre. With outward normals a negative z means the facet faces camera.
    (function windFaces(){
      var CENTER = { x:0, y:0.12, z:0 };
      for(var nf=0; nf<faces.length; nf++){
        var fi = faces[nf];
        var a0=verts[fi[0]], b0=verts[fi[1]], c0=verts[fi[2]];
        var ux0=b0.x-a0.x, uy0=b0.y-a0.y, uz0=b0.z-a0.z;
        var wx0=c0.x-a0.x, wy0=c0.y-a0.y, wz0=c0.z-a0.z;
        var nx0=uy0*wz0-uz0*wy0, ny0=uz0*wx0-ux0*wz0, nz0=ux0*wy0-uy0*wx0;
        var cx0=0, cy0=0, cz0=0;
        for(var ci=0; ci<fi.length; ci++){ cx0+=verts[fi[ci]].x; cy0+=verts[fi[ci]].y; cz0+=verts[fi[ci]].z; }
        cx0/=fi.length; cy0/=fi.length; cz0/=fi.length;
        if(nx0*(cx0-CENTER.x) + ny0*(cy0-CENTER.y) + nz0*(cz0-CENTER.z) < 0) fi.reverse();
      }
    })();

    // dust field
    var dust = [];
    for(var d=0;d<170;d++){
      var th = rnd()*Math.PI*2, ph = Math.acos(2*rnd()-1), rr = 1.7 + rnd()*2.0;
      dust.push({ x:Math.sin(ph)*Math.cos(th)*rr, y:Math.cos(ph)*rr*0.72, z:Math.sin(ph)*Math.sin(th)*rr, s:0.5+rnd()*1.4 });
    }
    // assay ring
    var RINGN = 90, ringPts = [];
    for(var k=0;k<RINGN;k++){
      var ka = (k/RINGN)*Math.PI*2;
      ringPts.push({ x:Math.cos(ka)*1.62, y:0, z:Math.sin(ka)*1.62 });
    }

    var yaw = 0.6, pitch = 0.22, tPitch = 0.22, tYawOff = 0, yawOff = 0;
    var lightA = 0.4, scanI = 0, scanAcc = 0;

    function rot(p, cy, sy, cp, sp){
      var x = p.x*cy - p.z*sy;
      var z = p.x*sy + p.z*cy;
      var y = p.y;
      var y2 = y*cp - z*sp;
      var z2 = y*sp + z*cp;
      return { x:x, y:y2, z:z2 };
    }

    var W=0,H=0,SC=1,CX=0,CY=0;
    function resize(){
      var rect = cv.getBoundingClientRect();
      var dpr = Math.min(window.devicePixelRatio||1, 2);
      var w = Math.max(1, Math.round(rect.width*dpr));
      var h = Math.max(1, Math.round(rect.height*dpr));
      if(w!==cv.width || h!==cv.height){ cv.width=w; cv.height=h; }
      W = cv.width; H = cv.height;
      SC = Math.min(W,H)*0.29;
      CX = W*0.5; CY = H*0.46;
    }

    function project(p){
      var D = 5.2;
      var k = D/(D + p.z);
      return { x:CX + p.x*SC*k, y:CY + p.y*SC*k, k:k };
    }

    function draw(dt){
      resize();
      if(!W || !H) return;
      ctx.clearRect(0,0,W,H);

      var ry = yaw + yawOff;
      var cy=Math.cos(ry), sy=Math.sin(ry), cp=Math.cos(pitch), sp=Math.sin(pitch);

      // ambient light blades
      var g0 = ctx.createRadialGradient(CX, CY*0.82, 0, CX, CY*0.82, Math.max(W,H)*0.62);
      g0.addColorStop(0,'rgba(40,44,54,0.55)');
      g0.addColorStop(1,'rgba(6,6,8,0)');
      ctx.fillStyle = g0; ctx.fillRect(0,0,W,H);

      // dust behind
      var rd = [];
      for(var i=0;i<dust.length;i++){
        var rp = rot(dust[i], cy, sy, cp, sp);
        rd.push({ p:rp, s:dust[i].s });
      }
      rd.sort(function(a,b){ return b.p.z - a.p.z; });
      for(var i2=0;i2<rd.length;i2++){
        var pr = project(rd[i2].p);
        var alpha = Math.max(0, Math.min(1, 0.16 + rd[i2].p.z*-0.11));
        var sz = rd[i2].s * pr.k * (W/900) * 1.5;
        ctx.fillStyle = 'rgba(198,203,209,'+alpha.toFixed(3)+')';
        ctx.fillRect(pr.x-sz*0.5, pr.y-sz*0.5, sz, sz);
      }

      // assay ring, tilted, with a leading scan node
      ctx.beginPath();
      var scanPos = null;
      for(var rI=0;rI<ringPts.length;rI++){
        var base = ringPts[rI];
        var tilt = 0.42;
        var ty = base.y*Math.cos(tilt) - base.z*Math.sin(tilt);
        var tz = base.y*Math.sin(tilt) + base.z*Math.cos(tilt);
        var rp2 = rot({x:base.x,y:ty,z:tz}, cy, sy, cp, sp);
        var pp = project(rp2);
        if(rI===0) ctx.moveTo(pp.x,pp.y); else ctx.lineTo(pp.x,pp.y);
        if(rI===scanI) scanPos = pp;
      }
      ctx.closePath();
      ctx.strokeStyle = 'rgba(198,203,209,0.16)';
      ctx.lineWidth = Math.max(1, W/1100);
      ctx.stroke();

      // light direction, orbiting
      var lx = Math.cos(lightA)*0.72, ly = -0.58, lz = -0.62 + Math.sin(lightA)*0.3;
      var ll = Math.sqrt(lx*lx+ly*ly+lz*lz); lx/=ll; ly/=ll; lz/=ll;
      var hx = lx, hy = ly, hz = lz-1;
      var hl = Math.sqrt(hx*hx+hy*hy+hz*hz); hx/=hl; hy/=hl; hz/=hl;

      // rotate all verts once
      var rv = new Array(verts.length);
      for(var v=0;v<verts.length;v++) rv[v] = rot(verts[v], cy, sy, cp, sp);

      // build face list with depth + lighting
      var list = [], maxLum = 0;
      for(var f=0;f<faces.length;f++){
        var idx = faces[f];
        var a = rv[idx[0]], b = rv[idx[1]], c = rv[idx[2]];
        var ux=b.x-a.x, uy=b.y-a.y, uz=b.z-a.z;
        var wx=c.x-a.x, wy=c.y-a.y, wz=c.z-a.z;
        var nx=uy*wz-uz*wy, ny=uz*wx-ux*wz, nz=ux*wy-uy*wx;
        var nl=Math.sqrt(nx*nx+ny*ny+nz*nz)||1; nx/=nl; ny/=nl; nz/=nl;
        if(nz > -0.02) continue; // cull faces turned away from the camera
        var diff = Math.max(0, nx*lx + ny*ly + nz*lz);
        var spec = Math.pow(Math.max(0, nx*hx + ny*hy + nz*hz), 22);
        var fres = Math.pow(1 - Math.min(1, -nz), 3);
        var zsum = 0;
        for(var zi=0; zi<idx.length; zi++) zsum += rv[idx[zi]].z;
        var lum = diff*0.8 + spec*0.9;
        if(lum > maxLum) maxLum = lum;
        list.push({ idx:idx, z:zsum/idx.length, diff:diff, spec:spec, fres:fres });
      }
      list.sort(function(a,b){ return b.z - a.z; });

      for(var L=0;L<list.length;L++){
        var fc = list[L];
        ctx.beginPath();
        for(var pI=0;pI<fc.idx.length;pI++){
          var pt = project(rv[fc.idx[pI]]);
          if(pI===0) ctx.moveTo(pt.x,pt.y); else ctx.lineTo(pt.x,pt.y);
        }
        ctx.closePath();
        var dcoef = Math.pow(fc.diff, 1.45);
        var rr2 = 13 + 186*dcoef + 220*fc.spec + 92*fc.fres*0.45;
        var gg2 = 13 + 191*dcoef + 228*fc.spec + 118*fc.fres*0.45;
        var bb2 = 18 + 197*dcoef + 240*fc.spec + 155*fc.fres*0.45;
        ctx.fillStyle = 'rgb('+Math.min(255,rr2|0)+','+Math.min(255,gg2|0)+','+Math.min(255,bb2|0)+')';
        ctx.fill();
        ctx.strokeStyle = 'rgba(198,203,209,'+(0.10 + 0.3*fc.diff).toFixed(3)+')';
        ctx.lineWidth = Math.max(0.8, W/1400);
        ctx.stroke();
      }

      // scan node on the ring
      if(scanPos){
        ctx.save();
        ctx.shadowBlur = 16; ctx.shadowColor = 'rgba(200,222,255,0.9)';
        ctx.fillStyle = 'rgba(232,241,255,0.95)';
        var ns = Math.max(2.4, W/380);
        ctx.fillRect(scanPos.x-ns*0.5, scanPos.y-ns*0.5, ns, ns);
        ctx.restore();
      }

      // reflection pool
      var gr = ctx.createRadialGradient(CX, CY + SC*1.32, 0, CX, CY + SC*1.32, SC*1.35);
      gr.addColorStop(0,'rgba(160,178,205,0.16)');
      gr.addColorStop(1,'rgba(6,6,8,0)');
      ctx.fillStyle = gr;
      ctx.fillRect(0, CY + SC*0.7, W, H - (CY + SC*0.7));

      gemHud.axis = ((ry*180/Math.PI)%360+360)%360;
      gemHud.lum = maxLum;
      gemHud.scan = scanI;
    }

    var hudAxis=$('#hudAxis'), hudFacets=$('#hudFacets'), hudLum=$('#hudLum'), hudScan=$('#hudScan');
    var hudT = 0;
    function writeHud(){
      if(hudAxis) hudAxis.textContent = String(Math.round(gemHud.axis)).padStart(3,'0') + '°';
      if(hudFacets) hudFacets.textContent = String(gemHud.facets).padStart(2,'0');
      if(hudLum) hudLum.textContent = gemHud.lum.toFixed(2);
      if(hudScan) hudScan.textContent = String(gemHud.scan).padStart(2,'0') + ' / ' + RINGN;
    }

    // pointer parallax
    window.addEventListener('mousemove', function(e){
      var nx = (e.clientX/window.innerWidth - 0.5);
      var ny = (e.clientY/window.innerHeight - 0.5);
      tYawOff = nx*0.55;
      tPitch = 0.22 + ny*0.34;
    }, {passive:true});

    var inView = true;
    if('IntersectionObserver' in window){
      var io = new IntersectionObserver(function(es){
        for(var i=0;i<es.length;i++) inView = es[i].isIntersecting;
      }, {threshold:0.02});
      io.observe(cv);
    }

    var last = 0;
    function frame(ts){
      requestAnimationFrame(frame);
      if(!inView) return;
      var dt = last ? Math.min(0.05,(ts-last)/1000) : 0.016;
      last = ts;
      yawOff += (tYawOff - yawOff)*0.05;
      pitch += (tPitch - pitch)*0.05;
      yaw += dt*0.28;
      lightA += dt*0.55;
      hudT += dt;
      scanAcc += dt*24;
      scanI = Math.floor(scanAcc) % RINGN;
      draw(dt);
      if(hudT > 0.1){ hudT = 0; writeHud(); }
    }

    if(REDUCE){
      resize(); draw(0.016); writeHud();
      window.addEventListener('resize', function(){ resize(); draw(0.016); });
    } else {
      requestAnimationFrame(frame);
      window.addEventListener('resize', function(){ resize(); }, {passive:true});
    }
  })();

  /* ---------------------------------------------------------
     PRELOADER + HERO INTRO
     --------------------------------------------------------- */
  var pre = document.getElementById('preloader');
  var plBar = pre ? pre.querySelector('.pl-bar i') : null;
  var plPct = document.getElementById('plPct');
  var plMarks = pre ? $$('.pl-mark span', pre) : [];

  function heroIntro(){
    if(!hasGSAP) return;
    var tl = gsap.timeline();
    tl.to('#heroWord .mask>span',{yPercent:0,duration:1.05,ease:'power4.out',stagger:.08},0)
      .to('#heroEyebrow',{opacity:1,y:0,duration:.7,ease:'power2.out'},.15)
      .to('#heroLede',{opacity:1,y:0,duration:.8,ease:'power2.out'},.45)
      .to('.hero-actions > *',{opacity:1,y:0,duration:.7,ease:'power2.out',stagger:.09},.6)
      .to('#heroMarks span',{opacity:1,y:0,duration:.6,ease:'power2.out',stagger:.06},.75)
      .to('.hero-disc',{opacity:1,duration:.7},.9)
      .to('.scroll-cue',{opacity:1,duration:.6},1)
      .fromTo('#heroStage',{opacity:0,scale:.94},{opacity:1,scale:1,duration:1.4,ease:'power3.out'},.15)
      .fromTo('.stage-corner',{opacity:0,scale:.2},{opacity:.55,scale:1,duration:.6,ease:'power2.out',stagger:.06},.9)
      .fromTo('.stage-hud div',{opacity:0,y:10},{opacity:1,y:0,duration:.6,ease:'power2.out',stagger:.07},1);
  }

  function primeHero(){
    if(!hasGSAP) return;
    gsap.set('#heroWord .mask>span',{yPercent:112});
    gsap.set('#heroEyebrow',{opacity:0,y:12});
    gsap.set('#heroLede',{opacity:0,y:18});
    gsap.set('.hero-actions > *',{opacity:0,y:18});
    gsap.set('#heroMarks span',{opacity:0,y:12});
    gsap.set('.hero-disc',{opacity:0});
    gsap.set('.scroll-cue',{opacity:0});
  }

  function startPreloader(){
    if(!pre) return;
    if(REDUCE || !hasGSAP){
      if(plBar) plBar.style.transform='scaleX(1)';
      pre.style.display='none';
      return;
    }
    primeHero();
    var tl = gsap.timeline();
    var prog = {v:0};
    gsap.set(plMarks,{yPercent:105,opacity:0});
    tl.to(plMarks,{yPercent:0,opacity:1,duration:.5,ease:'power3.out',stagger:.038},0)
      .to(plBar,{scaleX:1,duration:1.05,ease:'power2.inOut'},.12)
      .to(prog,{v:100,duration:1.05,ease:'power2.inOut',onUpdate:function(){
        if(plPct) plPct.textContent = String(Math.round(prog.v)).padStart(2,'0')+'%';
      }},.12)
      .to(plMarks,{yPercent:-105,duration:.42,ease:'power3.in',stagger:.026},'+=.08')
      .to('.pl-meta, .pl-bar',{opacity:0,duration:.26},'-=.28')
      .to(pre,{yPercent:-100,duration:.7,ease:'power4.inOut'},'-=.04')
      .add(function(){ pre.style.display='none'; })
      .add(heroIntro,'-=.18');
  }
  startPreloader();

  /* ---------------------------------------------------------
     LENIS (single instance) + anchors
     --------------------------------------------------------- */
  var lenis = null;
  if(!REDUCE && typeof window.Lenis !== 'undefined'){
    lenis = new Lenis({ duration:1.15, easing:function(t){ return Math.min(1, 1.001 - Math.pow(2,-10*t)); }, smoothWheel:true });
    if(hasST){
      lenis.on('scroll', ScrollTrigger.update);
      gsap.ticker.add(function(t){ lenis.raf(t*1000); });
      gsap.ticker.lagSmoothing(0);
    } else {
      var rafLoop = function(t){ lenis.raf(t); requestAnimationFrame(rafLoop); };
      requestAnimationFrame(rafLoop);
    }
  }
  $$('a[href^="#"]').forEach(function(a){
    a.addEventListener('click', function(e){
      var id = a.getAttribute('href');
      if(!id || id.length < 2) return;
      var el = document.querySelector(id);
      if(!el) return;
      e.preventDefault();
      if(lenis) lenis.scrollTo(el,{offset:-70,duration:1.3});
      else el.scrollIntoView({behavior: REDUCE ? 'auto' : 'smooth'});
    });
  });

  /* ---------------------------------------------------------
     CURSOR + MAGNETIC BUTTONS
     --------------------------------------------------------- */
  (function cursor(){
    var c=document.getElementById('cursor'), d=document.getElementById('cursorDot');
    if(!c||!d||window.matchMedia('(hover:none)').matches) return;
    var cx=innerWidth/2, cy=innerHeight/2, dx=cx, dy=cy, tx=cx, ty=cy;
    window.addEventListener('mousemove', function(e){ tx=e.clientX; ty=e.clientY; }, {passive:true});
    (function loop(){
      cx+=(tx-cx)*0.16; cy+=(ty-cy)*0.16; dx+=(tx-dx)*0.42; dy+=(ty-dy)*0.42;
      c.style.transform='translate('+cx+'px,'+cy+'px)';
      d.style.transform='translate('+dx+'px,'+dy+'px)';
      requestAnimationFrame(loop);
    })();
    $$('[data-cursor], a, button').forEach(function(el){
      el.addEventListener('mouseenter', function(){ c.classList.add('hover'); });
      el.addEventListener('mouseleave', function(){ c.classList.remove('hover'); });
    });
    document.addEventListener('mouseleave', function(){ c.classList.add('hidden'); d.classList.add('hidden'); });
    document.addEventListener('mouseenter', function(){ c.classList.remove('hidden'); d.classList.remove('hidden'); });
  })();

  (function magnetic(){
    if(!hasGSAP || REDUCE || window.matchMedia('(hover:none)').matches) return;
    $$('[data-magnetic]').forEach(function(el){
      el.addEventListener('pointermove', function(e){
        var r = el.getBoundingClientRect();
        gsap.to(el,{ x:(e.clientX-r.left-r.width/2)*0.24, y:(e.clientY-r.top-r.height/2)*0.32, duration:.5, ease:'power3.out' });
      });
      el.addEventListener('pointerleave', function(){
        gsap.to(el,{ x:0, y:0, duration:.7, ease:'elastic.out(1,0.5)' });
      });
    });
  })();

  /* ---------------------------------------------------------
     TOPBAR + PROGRESS + NAV GEM
     --------------------------------------------------------- */
  (function topbar(){
    var bar=document.getElementById('topbar'), prog=document.getElementById('progress'), gem=document.getElementById('navGem');
    function upd(){
      var y = window.scrollY || window.pageYOffset;
      if(bar) bar.classList.toggle('up', y > 70);
      var h = document.documentElement.scrollHeight - innerHeight;
      var p = h > 0 ? Math.min(1, y/h) : 0;
      if(prog) prog.style.transform = 'scaleX('+p+')';
      if(gem) gem.style.transform = 'rotate('+(45 + p*360)+'deg)';
    }
    if(hasST) ScrollTrigger.create({start:0,end:'max',onUpdate:upd});
    window.addEventListener('scroll', upd, {passive:true});
    upd();
  })();

  /* ---------------------------------------------------------
     ANNOUNCEMENT ROLLER
     --------------------------------------------------------- */
  (function annRoll(){
    var list = document.getElementById('annList');
    if(!list) return;
    var items = list.children.length;
    if(items < 2) return;
    if(REDUCE || !hasGSAP) return;
    var i = 0;
    setInterval(function(){
      i = (i+1) % items;
      gsap.to(list,{ y: -34*i, duration:.75, ease:'power3.inOut' });
    }, 3800);
  })();

  /* ---------------------------------------------------------
     FILTERS
     --------------------------------------------------------- */
  (function filters(){
    var bar = document.getElementById('filterBar');
    var grid = document.getElementById('grid');
    if(!bar || !grid) return;
    var cards = $$('.pcard', grid);

    $$('.fchip', bar).forEach(function(chip){
      var key = chip.getAttribute('data-filter');
      var n = key==='all' ? cards.length : cards.filter(function(c){ return c.getAttribute('data-cat')===key; }).length;
      var i = chip.querySelector('i');
      if(i) i.textContent = String(n).padStart(2,'0');
    });

    bar.addEventListener('click', function(e){
      var chip = e.target.closest ? e.target.closest('.fchip') : null;
      if(!chip) return;
      $$('.fchip', bar).forEach(function(c){ c.classList.remove('on'); });
      chip.classList.add('on');
      var key = chip.getAttribute('data-filter');
      var shown = [];
      cards.forEach(function(c){
        var match = (key==='all') || c.getAttribute('data-cat')===key;
        if(match){ c.style.display=''; shown.push(c); }
        else c.style.display='none';
      });
      if(hasGSAP && !REDUCE){
        gsap.fromTo(shown,{opacity:0,y:26},{opacity:1,y:0,duration:.6,ease:'power3.out',stagger:.05,overwrite:true});
      }
      if(hasST) ScrollTrigger.refresh();
    });
  })();

  /* ---------------------------------------------------------
     LOT ARCHIVE TERMINAL
     --------------------------------------------------------- */
  (function lookup(){
    var chips = document.getElementById('lotChips');
    var out = document.getElementById('termOut');
    var lotLabel = document.getElementById('termLot');
    if(!chips || !out) return;

    var RECORDS = [
      { lot:'OBS-24-1142', body:'CATALOG      OBS-GHK-050 / GHK-Cu\nFILLED       2026-05-18 · Line 02 · Analyst KV\nAPPEARANCE   Blue lyophilized powder\nIDENTITY     ESI-MS [M+H] 404.9        [OK]\nPURITY       99.42% HPLC 214 nm        [OK]\nWATER        3.1% Karl Fischer         [OK]\nMETALS       under 10 ppm              [OK]\nENDOTOXIN    under 0.5 EU/mg           [OK]\nRELEASED     2026-05-21 · QA K. Voss\nRETAIN       2029-05' },
      { lot:'OBS-24-1150', body:'CATALOG      OBS-A1MQ-050 / 5-Amino-1MQ\nFILLED       2026-06-02 · Line 01 · Analyst DR\nAPPEARANCE   Off-white lyophilized powder\nIDENTITY     ESI-MS [M] 159.1          [OK]\nPURITY       99.18% HPLC 214 nm        [OK]\nWATER        2.4% Karl Fischer         [OK]\nMETALS       under 10 ppm              [OK]\nENDOTOXIN    under 0.5 EU/mg           [OK]\nRELEASED     2026-06-05 · QA K. Voss\nRETAIN       2029-06' },
      { lot:'OBS-25-0207', body:'CATALOG      OBS-GHK-250 / GHK-Cu bulk\nFILLED       2026-02-07 · Line 02 · Analyst KV\nAPPEARANCE   Blue lyophilized powder\nIDENTITY     ESI-MS [M+H] 404.9        [OK]\nPURITY       99.51% HPLC 214 nm        [OK]\nWATER        2.9% Karl Fischer         [OK]\nMETALS       under 10 ppm              [OK]\nENDOTOXIN    under 0.5 EU/mg           [OK]\nRELEASED     2026-02-11 · QA M. Renn\nRETAIN       2029-02' },
      { lot:'OBS-25-0311', body:'CATALOG      OBS-A1MQ-250 / 5-Amino-1MQ bulk\nFILLED       2026-03-11 · Line 01 · Analyst DR\nAPPEARANCE   Off-white lyophilized powder\nIDENTITY     ESI-MS [M] 159.1          [OK]\nPURITY       99.22% HPLC 214 nm        [OK]\nWATER        2.2% Karl Fischer         [OK]\nMETALS       under 10 ppm              [OK]\nENDOTOXIN    under 0.5 EU/mg           [OK]\nRELEASED     2026-03-14 · QA M. Renn\nRETAIN       2029-03' }
    ];

    var typing = null;
    function render(text){
      out.textContent = '';
      if(typing){ clearInterval(typing); typing = null; }
      if(REDUCE){ out.textContent = text; return; }
      var i = 0;
      typing = setInterval(function(){
        i += Math.max(2, Math.round(text.length/140));
        out.textContent = text.slice(0, i);
        if(i >= text.length){ clearInterval(typing); typing = null; out.textContent = text; }
      }, 16);
    }

    function pick(n){
      var rec = RECORDS[n] || RECORDS[0];
      if(lotLabel) lotLabel.textContent = rec.lot;
      render(rec.body);
    }

    chips.addEventListener('click', function(e){
      var b = e.target.closest ? e.target.closest('.lot-chip') : null;
      if(!b) return;
      $$('.lot-chip', chips).forEach(function(c){ c.classList.remove('on'); });
      b.classList.add('on');
      pick(parseInt(b.getAttribute('data-lot')||'0', 10));
    });

    var started = false;
    function boot(){ if(started) return; started = true; pick(0); }
    if('IntersectionObserver' in window){
      var io = new IntersectionObserver(function(es){
        for(var i=0;i<es.length;i++){ if(es[i].isIntersecting) boot(); }
      }, {threshold:0.2});
      io.observe(out);
    } else { boot(); }
  })();

  /* ---------------------------------------------------------
     FAQ
     --------------------------------------------------------- */
  (function faq(){
    var list = document.getElementById('faqList');
    if(!list) return;
    function animate(a, open){
      var inner = a.querySelector('.inner');
      var h = inner.offsetHeight;
      if(hasGSAP){
        gsap.to(a,{ height: open ? h : 0, duration:.5, ease:'power3.inOut', onComplete:function(){ if(open) a.style.height='auto'; if(hasST) ScrollTrigger.refresh(); } });
      } else {
        a.style.height = open ? h+'px' : '0px';
      }
    }
    $$('.faq-item', list).forEach(function(item){
      var q = item.querySelector('.faq-q');
      var a = item.querySelector('.faq-a');
      q.addEventListener('click', function(){
        var open = item.classList.contains('open');
        $$('.faq-item.open', list).forEach(function(o){
          if(o!==item){ o.classList.remove('open'); animate(o.querySelector('.faq-a'), false); }
        });
        item.classList.toggle('open', !open);
        animate(a, !open);
      });
    });
  })();

  /* ---------------------------------------------------------
     NEWSLETTER MOCK
     --------------------------------------------------------- */
  (function news(){
    var form = document.getElementById('newsForm');
    var msg = document.getElementById('formMsg');
    if(!form) return;
    form.addEventListener('submit', function(e){
      e.preventDefault();
      if(!msg) return;
      msg.textContent = 'Demo form. Nothing was sent.';
      if(hasGSAP) gsap.fromTo(msg,{opacity:0,y:8},{opacity:1,y:0,duration:.5,ease:'power2.out'});
      else msg.style.opacity = 1;
    });
  })();

  /* ---------------------------------------------------------
     SCROLL CHOREOGRAPHY
     --------------------------------------------------------- */
  if(hasST && !REDUCE){

    // headline treatments
    $$('[data-split]').forEach(function(node){
      if(hasSplit){
        try{
          var s = new SplitText(node,{type:'lines',linesClass:'sline'});
          s.lines.forEach(function(l){ l.style.overflow='hidden'; });
          gsap.set(s.lines,{yPercent:112});
          ScrollTrigger.create({trigger:node,start:'top 84%',once:true,onEnter:function(){
            gsap.to(s.lines,{yPercent:0,duration:1,ease:'power4.out',stagger:.09});
          }});
          return;
        }catch(err){}
      }
      gsap.set(node,{yPercent:16,opacity:0});
      ScrollTrigger.create({trigger:node,start:'top 86%',once:true,onEnter:function(){
        gsap.to(node,{yPercent:0,opacity:1,duration:1,ease:'power3.out'});
      }});
    });

    $$('[data-mani]').forEach(function(m,i){
      var span = m.querySelector('span');
      gsap.set(span,{yPercent:120});
      ScrollTrigger.create({trigger:m,start:'top 90%',once:true,onEnter:function(){
        gsap.to(span,{yPercent:0,duration:1.1,ease:'power4.out',delay:i*0.06});
      }});
    });

    $$('[data-reveal]').forEach(function(el){
      gsap.set(el,{y:30,opacity:0});
      ScrollTrigger.create({trigger:el,start:'top 90%',once:true,onEnter:function(){
        gsap.to(el,{y:0,opacity:1,duration:.9,ease:'power3.out'});
      }});
    });

    // selling points: icon draw + glowline
    $$('[data-promise]').forEach(function(cell,i){
      var strokes = $$('[data-draw]', cell);
      strokes.forEach(function(s){
        var len = (s.getTotalLength ? s.getTotalLength() : 160) || 160;
        s.style.strokeDasharray = len; s.style.strokeDashoffset = len;
      });
      gsap.set(cell.children,{opacity:0,y:24});
      ScrollTrigger.create({trigger:cell,start:'top 84%',once:true,onEnter:function(){
        gsap.to(cell.children,{opacity:1,y:0,duration:.8,ease:'power3.out',stagger:.07,delay:i*0.1});
        gsap.to(strokes,{strokeDashoffset:0,duration:1.25,ease:'power2.out',stagger:.05,delay:i*0.1+0.15});
        var gl = cell.querySelector('.glowline');
        if(gl) gsap.to(gl,{scaleX:1,duration:1,ease:'power2.out',delay:i*0.1+0.55});
      }});
    });

    // product cards
    $$('.pcard').forEach(function(c,i){
      gsap.set(c,{y:46,opacity:0});
      ScrollTrigger.create({trigger:c,start:'top 90%',once:true,onEnter:function(){
        gsap.to(c,{y:0,opacity:1,duration:.95,ease:'power3.out',delay:(i%4)*0.08});
      }});
    });

    // filter bar + grid note
    gsap.set('#filterBar .fchip',{opacity:0,y:14});
    ScrollTrigger.create({trigger:'#filterBar',start:'top 92%',once:true,onEnter:function(){
      gsap.to('#filterBar .fchip',{opacity:1,y:0,duration:.6,ease:'power3.out',stagger:.06});
    }});

    // story chapter: chromatogram draw + purity counter, pinned on desktop
    (function story(){
      var trace = document.getElementById('chromoTrace');
      var glow = document.getElementById('peakGlow');
      var fill = document.getElementById('peakFill');
      var num = document.getElementById('purityCount');
      var stage = document.getElementById('storyStage');
      if(!trace || !stage) return;

      var tLen = trace.getTotalLength();
      trace.style.strokeDasharray = tLen; trace.style.strokeDashoffset = tLen;
      if(glow){ var gLen = glow.getTotalLength(); glow.style.strokeDasharray = gLen; glow.style.strokeDashoffset = gLen; }
      var counter = {v:0};
      if(num) num.textContent = '0.0';

      function build(pin){
        var tl = gsap.timeline({ scrollTrigger:{
          trigger:'#story',
          start: pin ? 'top top' : 'top 78%',
          end: pin ? '+=130%' : 'bottom 55%',
          scrub:.8,
          pin: pin ? stage : false,
          anticipatePin: pin ? 1 : 0
        }});
        tl.to(trace,{strokeDashoffset:0,duration:2,ease:'none'},0)
          .to(counter,{v:99.9,duration:2,ease:'none',onUpdate:function(){ if(num) num.textContent = counter.v.toFixed(1); }},0)
          .to(glow,{strokeDashoffset:0,opacity:1,duration:1,ease:'none'},1.1)
          .to(fill,{opacity:1,duration:.8,ease:'none'},1.4);
        return tl;
      }

      if(gsap.matchMedia){
        var mm = gsap.matchMedia();
        mm.add('(min-width: 1024px)', function(){
          var tl = build(true);
          return function(){ if(tl.scrollTrigger) tl.scrollTrigger.kill(true); tl.kill(); };
        });
        mm.add('(max-width: 1023px)', function(){
          var tl = build(false);
          return function(){ if(tl.scrollTrigger) tl.scrollTrigger.kill(true); tl.kill(); };
        });
      } else {
        build(false);
      }
    })();

    // cold chain: temperature descent, frost sweep, crystal draw
    (function cold(){
      var num = document.getElementById('tempCount');
      var dot = document.getElementById('tempDot');
      var frost = document.getElementById('frostCard');
      var track = dot ? dot.parentElement : null;
      var ice = $$('#crystal [data-ice] path');
      ice.forEach(function(p){
        var len = (p.getTotalLength ? p.getTotalLength() : 200) || 200;
        p.style.strokeDasharray = len; p.style.strokeDashoffset = len;
      });
      ScrollTrigger.create({trigger:'#crystal',start:'top 88%',once:true,onEnter:function(){
        gsap.to(ice,{strokeDashoffset:0,duration:1.4,ease:'power2.out',stagger:.08});
      }});
      if(!num) return;
      var t = {v:25};
      ScrollTrigger.create({
        trigger:'#cold', start:'top 72%', end:'bottom 62%', scrub:.6,
        onUpdate:function(self){
          var p = self.progress;
          t.v = 25 + (-45)*p;
          num.textContent = (t.v>=0 ? '+' : '') + Math.round(t.v);
          if(dot && track){
            var w = track.clientWidth || 300;
            dot.style.transform = 'translateX('+(p*(w-8))+'px)';
          }
          if(frost && p > 0.15) frost.classList.add('frost-on');
        }
      });
    })();

    // reviews: card stagger + star pops
    $$('[data-rev]').forEach(function(card,i){
      gsap.set(card,{y:40,opacity:0});
      var stars = $$('.stars i', card);
      gsap.set(stars,{scale:0,rotate:45});
      ScrollTrigger.create({trigger:card,start:'top 88%',once:true,onEnter:function(){
        gsap.to(card,{y:0,opacity:1,duration:.9,ease:'power3.out',delay:(i%4)*0.09});
        gsap.to(stars,{scale:1,rotate:45,duration:.45,ease:'back.out(2.4)',stagger:.06,delay:(i%4)*0.09+0.2});
      }});
    });

    // stat counters
    $$('[data-stat]').forEach(function(el){
      var target = parseFloat(el.getAttribute('data-stat'))||0;
      var dec = parseInt(el.getAttribute('data-dec')||'0',10);
      var suffix = el.getAttribute('data-suffix')||'';
      var o = {v:0};
      ScrollTrigger.create({trigger:el,start:'top 92%',once:true,onEnter:function(){
        gsap.to(o,{v:target,duration:1.6,ease:'power2.out',onUpdate:function(){
          var s = dec ? o.v.toFixed(dec) : Math.round(o.v).toLocaleString('en-US');
          el.textContent = s + suffix;
        }});
      }});
    });

    // collection tiles
    $$('[data-tile]').forEach(function(tile,i){
      gsap.set(tile,{y:44,opacity:0});
      var art = tile.querySelector('.tile-art');
      ScrollTrigger.create({trigger:tile,start:'top 90%',once:true,onEnter:function(){
        gsap.to(tile,{y:0,opacity:1,duration:1,ease:'power3.out',delay:i*0.09});
        if(art) gsap.fromTo(art,{scale:1.16},{scale:1,duration:1.5,ease:'power3.out',delay:i*0.09});
      }});
      if(art){
        ScrollTrigger.create({trigger:tile,start:'top bottom',end:'bottom top',scrub:.7,onUpdate:function(self){
          gsap.set(art,{yPercent:(self.progress-0.5)*10});
        }});
      }
    });

    // terminal panel
    gsap.set('.terminal',{opacity:0,y:40});
    ScrollTrigger.create({trigger:'.terminal',start:'top 86%',once:true,onEnter:function(){
      gsap.to('.terminal',{opacity:1,y:0,duration:1,ease:'power3.out'});
    }});
    gsap.set('#lotChips .lot-chip',{opacity:0,y:14});
    ScrollTrigger.create({trigger:'#lotChips',start:'top 92%',once:true,onEnter:function(){
      gsap.to('#lotChips .lot-chip',{opacity:1,y:0,duration:.6,ease:'power3.out',stagger:.07});
    }});

    // compare rows
    $$('[data-cmp]').forEach(function(row,i){
      var sweep = document.createElement('div');
      sweep.className = 'sweep';
      row.insertBefore(sweep, row.firstChild);
      gsap.set(row,{opacity:0,x:-14});
      ScrollTrigger.create({trigger:row,start:'top 92%',once:true,onEnter:function(){
        gsap.to(row,{opacity:1,x:0,duration:.7,ease:'power2.out',delay:i*0.07});
        gsap.fromTo(sweep,{xPercent:-100},{xPercent:200,duration:1.1,ease:'power2.inOut',delay:i*0.07+0.15});
      }});
    });

    // faq rows
    $$('#faqList .faq-item').forEach(function(item,i){
      gsap.set(item,{opacity:0,y:20});
      ScrollTrigger.create({trigger:item,start:'top 94%',once:true,onEnter:function(){
        gsap.to(item,{opacity:1,y:0,duration:.7,ease:'power3.out',delay:i*0.05});
      }});
    });

    // signup band
    gsap.set('#newsForm > *',{opacity:0,y:20});
    gsap.set('.disclaimer-strip',{opacity:0,y:20});
    ScrollTrigger.create({trigger:'#newsForm',start:'top 90%',once:true,onEnter:function(){
      gsap.to('#newsForm > *',{opacity:1,y:0,duration:.8,ease:'power3.out',stagger:.1});
      gsap.to('.disclaimer-strip',{opacity:1,y:0,duration:.9,ease:'power3.out',delay:.25});
    }});

    // footer marquee, speed bound to scroll velocity
    (function marquee(){
      var track = document.getElementById('footTrack');
      if(!track || !track.children.length) return;
      var first = track.children[0];
      var w = first.getBoundingClientRect().width + 56;
      var tw = gsap.to(track,{x:-w,duration:24,ease:'none',repeat:-1});
      ScrollTrigger.create({trigger:'footer',start:'top bottom',end:'bottom top',
        onUpdate:function(self){
          var v = Math.abs(self.getVelocity());
          tw.timeScale(Math.min(5, 1 + v/900));
        },
        onLeave:function(){ tw.timeScale(1); },
        onLeaveBack:function(){ tw.timeScale(1); }
      });
    })();

    if(document.fonts && document.fonts.ready){
      document.fonts.ready.then(function(){ ScrollTrigger.refresh(); });
    }
    window.addEventListener('load', function(){ ScrollTrigger.refresh(); });
    ScrollTrigger.refresh();
  }

  /* ---------------------------------------------------------
     EASTER EGG · type "obsidian" for a platinum sweep
     --------------------------------------------------------- */
  (function egg(){
    var seq='obsidian', buf='';
    window.addEventListener('keydown', function(e){
      if(!e.key || e.key.length!==1) return;
      buf = (buf + e.key.toLowerCase()).slice(-seq.length);
      if(buf===seq){
        var s = document.createElement('div');
        s.style.cssText='position:fixed;inset:0;z-index:140;pointer-events:none;background:linear-gradient(115deg,transparent 40%,rgba(232,241,255,.5) 50%,transparent 60%);background-size:250% 100%;background-position:120% 0';
        document.body.appendChild(s);
        if(hasGSAP) gsap.to(s,{backgroundPosition:'-120% 0',duration:1.2,ease:'power2.inOut',onComplete:function(){ s.remove(); }});
        else setTimeout(function(){ s.remove(); }, 1200);
      }
    });
  })();

  /* ---------------------------------------------------------
     TOOL BUTTON PRESS (search and account are demo placeholders)
     --------------------------------------------------------- */
  $$('.tool').forEach(function(b){
    b.addEventListener('pointerdown', function(){
      if(hasGSAP && !REDUCE) gsap.fromTo(b,{scale:1},{scale:.88,duration:.12,ease:'power2.out',yoyo:true,repeat:1});
    });
  });

  // final safety: if GSAP never arrived, make sure the preloader cannot trap the page
  if(!hasGSAP && pre){ pre.style.display = 'none'; }
})();


(function(){
  'use strict';
  function qs(s,r){return (r||document).querySelector(s)}
  function qsa(s,r){return Array.from((r||document).querySelectorAll(s))}
  function lock(on){document.documentElement.classList.toggle('obs-lock',on)}
  function initHeader(root){
    var scope=root||document, open=qs('[data-drawer-open]',scope), drawer=qs('[data-mobile-drawer]',document), backdrop=qs('[data-drawer-backdrop]',document), close=qs('[data-drawer-close]',document);
    if(open && !open.dataset.ready){open.dataset.ready='1';open.addEventListener('click',function(){drawer.classList.add('on');backdrop.classList.add('on');drawer.setAttribute('aria-hidden','false');lock(true);close&&close.focus()})}
    function shut(){drawer&&drawer.classList.remove('on');backdrop&&backdrop.classList.remove('on');drawer&&drawer.setAttribute('aria-hidden','true');lock(false);open&&open.focus()}
    if(close&&!close.dataset.ready){close.dataset.ready='1';close.addEventListener('click',shut)}
    if(backdrop&&!backdrop.dataset.ready){backdrop.dataset.ready='1';backdrop.addEventListener('click',shut)}
    qsa('a',drawer).forEach(function(a){if(!a.dataset.ready){a.dataset.ready='1';a.addEventListener('click',shut)}})
    document.addEventListener('keydown',function(e){if(e.key==='Escape')shut()},{once:false});
    var searchOpen=qs('[data-search-open]',scope), modal=qs('[data-search-modal]',document), searchClose=qs('[data-search-close]',document), searchBack=qs('[data-search-backdrop]',document);
    function showSearch(){modal.classList.add('on');modal.setAttribute('aria-hidden','false');lock(true);setTimeout(function(){qs('input[type="search"]',modal)?.focus()},40)}
    function hideSearch(){modal.classList.remove('on');modal.setAttribute('aria-hidden','true');lock(false);searchOpen&&searchOpen.focus()}
    if(searchOpen&&!searchOpen.dataset.ready){searchOpen.dataset.ready='1';searchOpen.addEventListener('click',showSearch)}
    if(searchClose&&!searchClose.dataset.ready){searchClose.dataset.ready='1';searchClose.addEventListener('click',hideSearch)}
    if(searchBack&&!searchBack.dataset.ready){searchBack.dataset.ready='1';searchBack.addEventListener('click',hideSearch)}
  }
  function initShelves(root){
    qsa('[data-obsidian-shelf]',root||document).forEach(function(sec){
      if(sec.dataset.ready)return;sec.dataset.ready='1';
      var cards=qsa('.pcard',sec), chips=qsa('[data-filter]',sec);
      chips.forEach(function(chip){chip.addEventListener('click',function(){
        chips.forEach(function(c){c.classList.remove('on')});chip.classList.add('on');var f=chip.dataset.filter;
        cards.forEach(function(card){card.hidden=!(f==='all'||card.dataset.cat===f)});
        if(window.ScrollTrigger)ScrollTrigger.refresh();
      })});
    })
  }
  function init(){initHeader(document);initShelves(document)}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',function(e){initHeader(e.target);initShelves(e.target);if(window.ScrollTrigger)requestAnimationFrame(function(){ScrollTrigger.refresh()})});
})();


/* Route B v3 component resilience */
(function(){
  function initObsidianFaq(scope){
    (scope||document).querySelectorAll('#faqList .faq-q').forEach(function(q){
      if(q.dataset.obsAriaReady) return;q.dataset.obsAriaReady='1';
      q.addEventListener('click',function(){setTimeout(function(){q.setAttribute('aria-expanded',String(q.closest('.faq-item').classList.contains('open')))},20)});
    });
  }
  function initFooterMarquee(scope){
    var track=(scope||document).querySelector('#footTrack');
    if(!track||track.dataset.obsMarqueeReady==='1'||typeof gsap==='undefined')return;
    track.dataset.obsMarqueeReady='1';
    var first=track.children[0];if(!first)return;
    requestAnimationFrame(function(){var w=first.getBoundingClientRect().width+56;if(w>0)gsap.to(track,{x:-w,duration:24,ease:'none',repeat:-1});});
  }
  document.addEventListener('DOMContentLoaded',function(){initObsidianFaq(document);initFooterMarquee(document)});
  document.addEventListener('shopify:section:load',function(e){initObsidianFaq(e.target);initFooterMarquee(e.target)});
})();
/* Mobile-adaptive canvases v2: phones change layout boxes after first paint
   (font load, URL-bar collapse, aspect-ratio media flips) without always
   firing a window resize. Watch each canvas's own box and replay the theme's
   resize path ONLY when the box genuinely changed — several heroes rebuild
   and replay their intro on resize, so a synthetic ping on load or on the
   observer's first callback would visibly restart them. */
(function () {
  if (!('ResizeObserver' in window)) return;
  var last = new WeakMap();
  var t;
  function ping() { clearTimeout(t); t = setTimeout(function () { window.dispatchEvent(new Event('resize')); }, 120); }
  var ro = new ResizeObserver(function (entries) {
    var changed = false;
    entries.forEach(function (en) {
      var r = en.target.getBoundingClientRect();
      var p = last.get(en.target);
      last.set(en.target, { w: r.width, h: r.height });
      if (p && (Math.abs(p.w - r.width) > 1 || Math.abs(p.h - r.height) > 1)) changed = true;
    });
    if (changed) ping();
  });
  function watch() { document.querySelectorAll('canvas').forEach(function (c) { ro.observe(c); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch);
  else watch();
  window.addEventListener('orientationchange', function () { setTimeout(ping, 200); });
})();
